import { useFormSistema } from '../../../hooks/useForm'
import { useViewSistema } from '../../../hooks/useView'
import { BotaoTitle } from '../botoes/BotaoTitle'

export function FormTitle(props){
    const { removeView } = useViewSistema()
    const { state: { botoes } } = useFormSistema()

    function renderBotoes() {
        //Cria botão de fechar internamente para ter o ID do form dono
        const botaoFechar = <BotaoTitle botao={{
            title: 'Fechar',
            marca: false,
            icone: 'times-circle',
            cor: 'danger',
            funcaoClick: removeView, //Envia como parâmetro a função após o bind
            parametro: props.idForm
        }} />

        if (props.idForm !== 'home') {
            //Adiciona botão nos botoes recebidos
            const btns = [...botoes, botaoFechar]

            return btns.map((b, index) => {
                return (
                    <div key={index}>
                        {b}
                    </div>
                )
            })
        }
    }

    return (
        <div className="content-header pr-0" id={`header-form-${props.chave}`}>
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col">
                        <h1 className="m-0 text-dark">{props.titulo}</h1>
                    </div>
                    <div className="col-auto d-flex pr-0">
                        {renderBotoes()}
                    </div>
                </div>
            </div>
        </div>
    )
}